// @core/api/endpoints/fiscalization/create_fiscal_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFiscalProviderRequest,
  CreateFiscalProviderResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Create fiscal provider
 * Registers a new fiscal provider (OFD or TSE) configuration with credentials and endpoint details.
 */
export async function CreateFiscalProvider(
  data: CreateFiscalProviderRequest,
  options?: RequestOptions
): Promise<CreateFiscalProviderResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-providers`;
  const requestOptions = options;
  return client.post<CreateFiscalProviderResponse>(requestPath, data, requestOptions);
}
